/**
 * @param {import('../constructionLog').ConstructionLog} constructionLog 
 */
export const fetchPdfss = constructionLog => {
  return Promise.all(constructionLog.log_pages.map(page => {
    let paths = page.attached_file_paths
      .filter(str => str.endsWith('.pdf'))
    return fetchPdfs(paths)
  }))
}

/**
 * Given paths to pdfs, returns Promise with pdfs
 * @param {string[]} paths 
 */
const fetchPdfs = paths =>
  Promise.all(paths.map(path => fetchPdf(path)))

/**
 * @param {string} path 
 * @returns {Promise<ArrayBuffer>}
 */
const fetchPdf = path =>
  fetch(path).then(res => res.arrayBuffer())